export default {"src":"/customer-services/_next/static/media/logo-my-john-lewis.89b6ed46.svg","height":18,"width":230,"blurWidth":0,"blurHeight":0};